import { FETCH_INSTITUTION_TREE_DETAILS, UPDATE_INSTITUTION_PACKAGE_TREE_DETAILS } from 'stores/redux/actions/types';
import hOReducer from '../common/reducer';

export const treeReducer = hOReducer(FETCH_INSTITUTION_TREE_DETAILS);
export const packageReducer = hOReducer(UPDATE_INSTITUTION_PACKAGE_TREE_DETAILS);
